export default __webpack_public_path__ + "static/media/central.0c29cfb9.jpeg";